import 'aframe'

import { Entity } from 'aframe-react'
import React, { Component } from 'react'

class SiloView extends Component {
  moveSiloPositionBottomConeHeightUp (position, bottomConeHeight) {
    const positionAxises = position.split(' ')
    // position is [x,y,z]
    positionAxises[1] = `${+positionAxises[1] + bottomConeHeight}`
    return positionAxises.join(' ')
  }

  ajustPositionToHeightForNucleo (position, height) {
    const positionAxises = position.split(' ')
    // position is [x,y,z]
    positionAxises[1] = `${+positionAxises[1] + height / 2 + height}`
    return positionAxises.join(' ')
  }

  ajustPositionToHeight (position, height) {
    const positionAxises = position.split(' ')
    // position is [x,y,z]
    positionAxises[1] = `${+positionAxises[1] + height / 2}`
    return positionAxises.join(' ')
  }

  moveTopConePositionBottomConeAndSiloHeightUp (position, siloHeight, bottomConeHeight) {
    const positionAxises = position.split(' ')
    // position is [x,y,z]
    positionAxises[1] = `${+positionAxises[1] + bottomConeHeight + siloHeight}`
    return positionAxises.join(' ')
  }

  render () {
    let {
      position,
      radius,
      height,
      color,
      topConeHeight = '0',
      bottomConeHeight = '0',
      onClick,
      isEntreSilo,
      nucleoColor,
      metrosLleno
    } = this.props
    if (color && !color.startsWith('#')) {
      color = '#' + color
    }
    const bottomConeToRender = bottomConeHeight ? (
      <>
        <Entity
          primitive='a-cone'
          position={this.ajustPositionToHeight(position, bottomConeHeight)}
          radius-bottom='0'
          radius-top={radius}
          height={bottomConeHeight}
          color={color}
          transparent
          opacity={0.5}
          events={{
            click: onClick
          }}
        />
        {/* <Entity
          primitive='a-cone'
          position={this.ajustPositionToHeight(position, bottomConeHeight)}
          radius-bottom='0.1'
          radius-top={`${+radius + 0.1}`}
          height={`${+bottomConeHeight + 0.1}`}
          color={nucleoColor}
          transparent
          opacity={0.3}
          events={{
            click: onClick
          }}
        /> */}
        <Entity
          primitive='a-cone'
          position={this.ajustPositionToHeight(position, bottomConeHeight)}
          radius-bottom='0'
          radius-top={`${metrosLleno > bottomConeHeight ? +radius - 0.01 : (radius * metrosLleno) / bottomConeHeight - 0.01}`}
          height={`${+bottomConeHeight - 0.01}`}
          color='grey'
          events={{
            click: onClick
          }}
        />
      </>
    ) : (
      ''
    )
    const topConeFill =
      metrosLleno > bottomConeHeight + height ? (
        <Entity
          primitive='a-cone'
          position={this.moveTopConePositionBottomConeAndSiloHeightUp(
            this.ajustPositionToHeight(
              position,
              metrosLleno > bottomConeHeight + height ? metrosLleno - (bottomConeHeight + height) - 0.01 : 0
            ),
            height,
            bottomConeHeight
          )}
          radius-bottom={`${+radius - 0.01}`}
          radius-top='0'
          height={`${metrosLleno > bottomConeHeight + height ? metrosLleno - (bottomConeHeight + height) - 0.01 : 0}`}
          color='grey'
          events={{
            click: onClick
          }}
        />
      ) : (
        ''
      )
    const topConeToRender = topConeHeight ? (
      <>
        <Entity
          primitive='a-cone'
          position={this.moveTopConePositionBottomConeAndSiloHeightUp(
            this.ajustPositionToHeight(position, topConeHeight),
            height,
            bottomConeHeight
          )}
          radius-bottom={radius}
          radius-top='0'
          height={topConeHeight}
          color={color}
          transparent
          opacity={0.5}
          events={{
            click: onClick
          }}
        />
        {/* <Entity
          primitive='a-cone'
          position={this.moveTopConePositionBottomConeAndSiloHeightUp(
            this.ajustPositionToHeight(position, topConeHeight),
            height,
            bottomConeHeight
          )}
          radius-bottom={`${+radius + 0.1}`}
          radius-top='0'
          height={`${+topConeHeight + 0.1}`}
          color={nucleoColor}
          transparent
          opacity={0.3}
          events={{
            click: onClick
          }}
        /> */}
        {topConeFill}
      </>
    ) : (
      ''
    )
    let entresiloRender = null
    if (isEntreSilo) {
      entresiloRender = (
        <>
          <Entity
            primitive='a-box'
            position={this.ajustPositionToHeight(position, height)}
            width={radius * 2}
            depth={radius * 2}
            height={height}
            rotation='0 45 0'
            color={color}
            transparent
            opacity={0.5}
            events={{
              click: onClick
            }}
          />
          {nucleoColor !== 'white' && (
            <Entity
              primitive='a-box'
              position={this.ajustPositionToHeightForNucleo(position, height)}
              width={radius * 2 + 0.1}
              depth={radius * 2 + 0.1}
              height={height / 5}
              rotation='0 45 0'
              color={nucleoColor}
              transparent
              opacity={0.3}
              events={{
                click: onClick
              }}
            />
          )}
          <Entity
            primitive='a-box'
            position={this.ajustPositionToHeight(position, metrosLleno > bottomConeHeight ? metrosLleno - bottomConeHeight : 0)}
            width={radius * 2 - 0.01}
            depth={radius * 2 - 0.01}
            height={metrosLleno > bottomConeHeight ? metrosLleno - bottomConeHeight : 0}
            rotation='0 45 0'
            color='grey'
            events={{
              click: onClick
            }}
          />
        </>
      )
    }
    let siloRender = null
    if (!isEntreSilo) {
      siloRender = (
        <>
          <Entity
            primitive='a-cylinder'
            position={this.moveSiloPositionBottomConeHeightUp(this.ajustPositionToHeight(position, height), bottomConeHeight)}
            radius={radius}
            height={height}
            color={color}
            transparent
            opacity={0.5}
            events={{
              click: onClick
            }}
          />
          {nucleoColor !== 'white' && (
            <Entity
              primitive='a-cylinder'
              position={this.moveSiloPositionBottomConeHeightUp(this.ajustPositionToHeightForNucleo(position, height), bottomConeHeight)}
              radius={radius + 0.1}
              height={height / 5}
              color={nucleoColor}
              transparent
              opacity={0.3}
              events={{
                click: onClick
              }}
            />
          )}
          <Entity
            primitive='a-cylinder'
            position={this.moveSiloPositionBottomConeHeightUp(
              this.ajustPositionToHeight(position, metrosLleno > bottomConeHeight ? metrosLleno - bottomConeHeight : 0),
              bottomConeHeight
            )}
            radius={radius - 0.01}
            height={
              metrosLleno > bottomConeHeight ? (metrosLleno > bottomConeHeight + height ? height : metrosLleno - bottomConeHeight) : 0
            }
            color='grey'
            events={{
              click: onClick
            }}
          />
          {topConeToRender}
          {bottomConeToRender}
        </>
      )
    }
    return (
      <>
        {entresiloRender}
        {siloRender}
        {topConeToRender}
        {bottomConeToRender}
      </>
    )
  }
}

export default SiloView
